<template>
  <div class="firstStart">
    <div class="right-menu__mobileApp">
      <div class="right-menu__title">
        <h4>Скачать приложение</h4>
      </div>
      <p class="confirm-block__text marginBottom">
        Теперь заказать и оплатить воду стало еще проще. Мы разработали
        приложение для вас. Скачать можно по ссылкам ниже.
      </p>
      <a
        href="https://apps.apple.com/ru/app/%D0%B8%D1%81%D1%82%D0%BE%D1%87%D0%BD%D0%B8%D0%BA-%D0%B7%D0%B4%D0%BE%D1%80%D0%BE%D0%B2%D1%8C%D1%8F-%D0%BC%D0%BE%D1%81%D0%BA%D0%B2%D0%B0-%D0%B8-%D0%BC%D0%BE/id1510995705"
        target="_blank"
        class="image"
      >
        <img src="/dist/images/ui/appstore.png" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=ru.aquadelivery.istochnikzdorovja.client"
        target="_blank"
        class="image"
      >
        <img src="/dist/images/ui/playmarket.png" />
      </a>
    </div>
    <div class="right-menu__cookies">
      <p class="confirm-block__text cookies">
        Используя наш сайт, вы соглашаетесь с использованием файлов cookie и
        сервисов сбора технических данных посетителей (IP-адресов,
        местоположения и др.) для обеспечения работоспособности и улучшения
        качества обслуживания.
        <a v-link href="/info/privacy" class="right-menu__link"
          ><span>Подробнее</span></a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
.firstStart
  height: 100%
  display: flex
  flex-direction: column
  justify-content: space-between
.marginBottom
  margin-bottom: 32px
.image
  display: inline-block
  margin-bottom: 12px
  transition: all .2s
  opacity: 1
  &:hover
    opacity: .8
  &:active
    transform: scale3d(.98, .98, .98)

.cookies
  @media screen and ( max-width: 1279px  )
    font-size: 14px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/mobileApp.vue